export default "__VITE_ASSET__654031c6__"